import SessionTelemetry from '../store/schema/SessionTelemetry';
import {
    SmartComposeInteraction,
    RejectionReason,
} from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import { owaDate } from 'owa-datetime';

export default function finalizeTelemetryForSession(
    existingSession: SessionTelemetry,
    allSuggestionsTelemetry: SmartComposeInteraction[],
    sessionEndReason: string,
    charactersTypedInSession: number
) {
    const now = owaDate();
    existingSession.sessionEndTime = now;
    existingSession.sessionEndReason = sessionEndReason;

    let suggestionsRequested: number = 0;
    let suggestionsReceived: number = 0;
    let suggestionsShown: number = 0;
    let suggestionsAccepted: number = 0;
    let suggestionsRejected: number = 0;
    allSuggestionsTelemetry.forEach(suggestion => {
        if (suggestion.sessionId === existingSession.sessionId) {
            suggestionsRequested++;
            if (suggestion.sessionId !== existingSession.sessionId) {
                return;
            }
            if (suggestion.suggestionReturned) {
                suggestionsReceived++;
            }
            if (suggestion.initialRenderTime) {
                suggestionsShown++;
            }
            if (suggestion.suggestionAcceptanceTime) {
                suggestionsAccepted++;
            } else if (
                suggestion.suggestionRejectionTime &&
                suggestion.rejectionReason !== RejectionReason.NotSeen
            ) {
                suggestionsRejected++;
            }
        }
    });

    existingSession.suggestionsRequested = suggestionsRequested;
    existingSession.suggestionsReceived = suggestionsReceived;
    existingSession.suggestionsShown = suggestionsShown;
    existingSession.suggestionsAccepted = suggestionsAccepted;
    existingSession.suggestionsRejected = suggestionsRejected;
    existingSession.charactersTypedInSession = charactersTypedInSession;
}
